<template>
    <div>
        <div class="text-center">
            <h2>Ευάγγελος Γιαννοθανάσης</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo-E-Giannothanasis.jpg')" />
                <p class="cv-text">
                    Ο Ευάγγελος Γιαννοθανάσης είναι Γεωπόνος, απόφοιτος του τμήματος του Επιστήμης Φυτικής Παραγωγής του Γεωπονικού Πανεπιστημίου Αθηνών. Εκπονεί την διδακτορική διατριβή με αντικείμενο την βελτιστοποίηση της θρέψης σε θερμοκηπιακές καλλιέργειες με έμφαση στην υδροπονία στο Εργαστήριο Κηπευτικών Καλλιεργειών του Γεωπονικού Πανεπιστημίου Αθηνών. Συμμετέχει στο ευρωπαϊκό πρόγραμμα ECONUTRI, HORIZON EUROPE ως ερευνητής εστιάζοντας στην ανάπτυξη του καινοτόμου συστήματος υποστήριξης αποφάσεων NUTRISENSE για την διαχείριση της θρέψης σε κλειστά υδροπονίκα συστήματα. Παράλληλα συμμετέχει σε προγράμματα εφαρμογής καινοτομίας του Υπομέτρου 16.1-16.2 του Υπουργείου Αγροτικής Ανάπτυξης και Τροφίμων. Τα κύρια ερευνητικά του ενδιαφέροντα περιλαμβάνουν θέματα σχετικά με τις ανάγκες και την διαχείριση της θρέψης και της άρδευσης των κηπευτικών που καλλιεργούνται τόσο υδροπονικά όσο και στο έδαφος, τον εξοπλισμό των υδροπονικών καλλιεργειών, καθώς και την μελέτη-διαχείριση αβιοτικών καταπονήσεων σε τέτοια συστήματα. Το συγγραφικό του έργο περιλαμβάνει 2 εργασίες δημοσιευμένες σε έγκριτα διεθνή επιστημονικά περιοδικά με κριτές, 3 επιστημονικές εργασίες σε πλήρη πρακτικά διεθνών συνεδρίων, και 3 επιστημονικές εργασίες σε εθνικά συνέδρια.
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
